import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import { RequestGetApprovalSettingDto, ResponseGetApprovalSettingDto, RequestProcessReplaceOfApproveDto } from "../dto/approval-setting.dto";
import { ResponsePaging, ResponseData } from "../../nest-responses";

@Injectable()
export class ApprovalSettingApi {
	private service: string = '';
	private model: string = 'sFApprovalSetting';

	constructor(
		private nestApiProvider: NestApiProvider
	) {
	}

	public getApprovalReplace(payload: RequestGetApprovalSettingDto): Observable<ResponsePaging<ResponseGetApprovalSettingDto>> {
		const method: string = 'POST';
		const func: string = 'getApprovalReplace';
		const params: any = {};
		const urlParams: any = payload || {};
		const body: any = {};
		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponsePaging<ResponseGetApprovalSettingDto>>(method, url, func, params, body);
	}

	processReplaceOfApprove(payload: Array<RequestProcessReplaceOfApproveDto>): Observable<ResponseData<any>> {
    const method: string = "POST";
    const func: string = "processReplaceOfApprove";
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, contentType);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/approval-setting.api.ts